import type { Select } from '@table-library/react-table-library/select'
import { useTranslation } from 'libs/i18n'
import { useDevice, usePagination } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { Pagination } from 'shared/atoms'
import { getCardTableStyles } from 'styles/table'
import { AreaType } from 'features/areaTypes/molecules/AreaType/AreaType'
import type { Option } from 'shared/components/ContextMenu/types'
import type { AreaTypeItem, AreaTypesRes } from 'features/areaTypes/types/areaTypes.types'
import { useColumns } from '../hooks/useColumns'

type TableSectionProps = {
	boothTypes: AreaTypesRes
	results: AreaTypeItem[]
	select: Select
	menuOptions: Option[]
}

export const TableSection = ({ boothTypes, results, select, menuOptions }: TableSectionProps) => {
	const { t } = useTranslation()
	const { isMobileOrTablet } = useDevice()
	const { handlePagination } = usePagination()
	const columns = useColumns({ menuOptions })

	const isPaginated = !!(boothTypes.data.next || boothTypes.data.previous)

	return (
		<>
			{isMobileOrTablet ? (
				<ul className="divide-y divide-border">
					{results.map((boothType) => (
						<AreaType key={boothType.id} boothType={boothType} menuOptions={menuOptions} />
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes: results }}
					isLoading={false}
					select={select}
					customStyles={getCardTableStyles(columns, { clickableRows: false })}
				/>
			)}
			<div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground">
				<span>
					{isPaginated
						? t('{{ count }} entries', { count: results.length })
						: t('{{ count }} of {{ total }} entries', {
								count: results.length,
								total: boothTypes.data.results.length
							})}
				</span>
				<Pagination
					prev={boothTypes.data.previous}
					next={boothTypes.data.next}
					onClick={handlePagination}
				/>
			</div>
		</>
	)
}
